import { usePropertyPreSold } from '../../../queries/PropertyFields/NonRentalFlagFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../components/ApplicationQuestionReviewItem';

interface PreSoldProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const PreSold: React.FC<PreSoldProps> = ({ propertyGuid, required = false, isReview = false }) => {
    const label = 'Pre-sold? ';
    const [preSold, set_preSold] = usePropertyPreSold(propertyGuid);

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_preSold(true);
                return;
            case 'no':
                set_preSold(false);
                return;
            default:
                return;
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={preSold ? 'Yes' : 'No'}
                />
            ) : (
                <YesNoToggleButton
                    id='toggleButtonPreSold'
                    value={preSold}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Pre-sold required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
